<footer class="px-2 px-md-4 col-md-12 text-center">
  <div class="container-fluid">
    <div class="row">
      <p class="copyright">Copyright © {{financialYearStart}}-{{financialYearEnd}} Track Opinion Research Private
        Limited. All Rights Reserved.</p>
      <button *ngIf="showOptOutBtn" (click)="onReject()" [disabled]="rdService.isProcessing || !rdService.RdResponsedone || (this.rdService.statusCode === 202 && !this.rdService.doRedirect)" type="button" class="btn btn-outline-common mt-2 opt-out-btn">Opt Out</button>
    </div>
  </div>
</footer>
